/**
 * Available AI models for LLM operations
 */
export var AIModel;
(function (AIModel) {
    AIModel["AZURE_GPT4"] = "azure-gpt4";
    AIModel["AZURE_GPT4_MINI"] = "azure-gpt4-mini";
    AIModel["GEMINI_1_5_FLASH"] = "gemini-1.5-flash";
    AIModel["GEMINI_2_5_FLASH"] = "gemini-2.5-flash";
    AIModel["GPT4"] = "gpt4";
    AIModel["GPT4_MINI"] = "gpt4-mini";
    AIModel["CLAUDE_3_5"] = "claude-3.5";
    AIModel["CLAUDE_SONNET_4_5"] = "claude-sonnet-4.5";
    AIModel["CLAUDE_HAIKU_4_5"] = "claude-haiku-4.5";
    AIModel["CLAUDE_OPUS_4_1"] = "claude-opus-4.1";
    AIModel["GROK_2"] = "grok-2";
    AIModel["LLAMA_4_SCOUT"] = "llama-4-scout";
    AIModel["DEEPSEEK_V3"] = "deepseek-v3";
})(AIModel || (AIModel = {}));
//# sourceMappingURL=AIModel.js.map